import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import InputTextField from "components/input/new/InputTextField";
import Label from "components/input/new/Label";

// Assets
import {greyishBlue500} from "assets/jss/main";
import {WMSContext} from "../../../../../views/wms/context/WMSContext";

WmsItemCodes.propTypes = {
    wmsItem: PropTypes.shape({
        lineItem: PropTypes.shape({
            variationSku: PropTypes.string,
        }),
        barcode: PropTypes.string,
    }).isRequired,
};

function WmsItemCodes({wmsItem}) {
    const {currentOrganization} = useContext(WMSContext)
    if (!wmsItem || !wmsItem.lineItem) {
        return null;
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Label htmlFor={`ean`} color={greyishBlue500}>
                    <FormattedMessage id='wms.myPickingMissions.popup.product.ean' />
                </Label>
                <InputTextField
                    value={wmsItem.barcode || ''}
                    fullWidth
                    disabled
                />
            </Grid>
            {currentOrganization?.wmsDisplayUgCode && (
                <Grid item xs={12}>
                    <Label htmlFor={`ug`} color={greyishBlue500}>
                        <FormattedMessage id='wms.myPickingMissions.popup.product.ug' />
                    </Label>
                    <InputTextField
                        value={wmsItem.lineItem.variationSku || ''}
                        fullWidth
                        disabled
                    />
                </Grid>
            )}
        </Grid>
    );
}

export default WmsItemCodes;
